@if (familyEnrollDefaults()?.memberId) {
<div class="family-enrollment-comtainer">
  <div class="sticky" [class.prd-sticky]="region === 'prod'">
    <div class="floating-banner">
      <div><a class="banner-breadcrumb-link" routerLink="/eligibility/family-enrollment">Manage Eligibility</a> / <span>Family Enrollment</span></div>
      <h4>Family Enrollment</h4>
    </div>
  </div>

  @if (clientDetails() && !displaySsnForm()) {
  <div class="enroll-family-container">
    <elig-enroll-family [key]="'BMT'"
                        (wasEnrollmentSuccess)="wasEnrollmentSuccess($event)"
                        (cancelFamilyEnrollment)="cancelFamilyEnrollment()"
                        [familyEnrollFeatures]="familyEnrollFeatures"
                        [selectedAdminPlan]="selectedAdminPlan()"
                        [familyEnrollDefaults]="$any(familyEnrollDefaults())"
                        [clientDetails]="clientDetails()"></elig-enroll-family>
  </div>
  }

  <rs-dialog [visible]="displaySsnForm()"
             (visibleChange)="displaySsnForm.set(false); cancelFamilyEnrollment();"
             heading="Enter Member Id"
             maxWidth="900px">
    @if (setDefaultsForm) {
    <ng-container>
      <form [formGroup]="setDefaultsForm" class="family-enorllment-defaults-form">
        <div class="defaults-for-family-enroll">
          <div>
            <rs-input label="Received Date" formControlName="receivedDate" type="date" strictDateTyping placeholder="MM/DD/YYYY"></rs-input>
            <rs-input label="Eligibility Effective Date" validation="eager" formControlName="eligibilityEffectiveDate" type="date" strictDateTyping placeholder="MM/DD/YYYY"></rs-input>
            <rs-select label="Eligibility Status" validation="eager" [items]="[{label: 'Active', value: 'active'}]" formControlName="eligibilityStatus"></rs-select>
            <rs-select label="Eligibility Status Reason" validation="eager" [items]="eligStatusReasons()" formControlName="eligibilityStatusReason"></rs-select>
          </div>
          <div>
            @if (qualifierTypes().length) {
            <rs-select validation="eager" label="Qualifier Type" [items]="qualifierTypes()" formControlName="qualifierType"></rs-select>
            }
            @if (memberBenefitTypes().length) {
            <rs-select validation="eager" label="Member Benefit Type" [items]="memberBenefitTypes()" formControlName="memberBenefitType"></rs-select>
            }
          </div>
        </div>
      </form>
    </ng-container>
    }

    <div class="ssn-inputs">
      @if (memberIdEntryMode() !== 'system') {
        @if (showCopyError()) {
        <p style="color: chocolate;padding: 20px 20px 0px 20px;"><code>Ctrl + C</code> / Copy is Not Allowed</p>
        }
        @if (addMemberForm()) {
        <ng-container>
          <form [formGroup]="addMemberForm()" (ngSubmit)="triggerFindMember()">
            <div class="form-and-buttons">
              <rs-input label="Member ID" validation="eager" formControlName="ssn" (keydown.control.c)="onKeyPress($event)" [type]="changeType()" [placeholder]="'No dashes or spaces'"></rs-input>
              <rs-input label="Confirm Member ID" validation="eager" formControlName="confirmSsn" (keydown.control.c)="onKeyPress($event)" type="password" [placeholder]="'No dashes or spaces'"></rs-input>
              <button type="submit" [disabled]="!addMemberForm()?.valid" rs-raised-button color="primary">SUBMIT</button>
              @if (memberIdEntryMode() === 'both') {
              <button type="button" class="generate-pseudo-ssn-button" [disabled]="addMemberForm()?.valid || isGeneratingPseudoSsn()" (click)="generatePseudoSsn()" rs-raised-button color="primary">GENERATE PSEUDO SSN</button>
              }
            </div>
          </form>
        </ng-container>
        }
      }
      @if (memberIdEntryMode() === 'system') {
      <div class="system-assigned-member-id">
        <p>A pseudo SSN will be generated for this member.</p>
        <button type="button" [disabled]="!setDefaultsForm?.valid || isGeneratingPseudoSsn()"
          (click)="continueWithGeneratedPseudoSsn()" rs-raised-button color="primary">CONTINUE</button>
      </div>
      }
      @if (isGeneratingPseudoSsn()) {
      <p>Generating pseudo SSN...</p>
      }
      @if (pseudoSsnError()) {
      <p style="color: red;">{{pseudoSsnError()}}</p>
      }
    </div>
  </rs-dialog>

  @if (findMemberFeed(); as memberFeed) {
  <elig-find-member [key]="'BMT'" [feed]="$any(memberFeed)" (foundMember)="foundMember($event)"></elig-find-member>
  }
</div>
} @else {
<p style="color: red;padding: 50px 50px 0;">
  No member id or defaults found to enroll a family
</p>
}
